/**
 * Official Google Play "Get it on Google Play" badge (black variant).
 *
 * Rendered as unmodified inline SVG per Google Play brand guidelines:
 *   https://play.google.com/intl/en_us/badges/
 *
 * DO NOT modify colors, add borders, gradients, effects INSIDE the badge,
 * or alter proportions. Container-level styling (drop shadow, hover lift)
 * is permitted since it does not modify the badge artwork itself.
 *
 * Minimum height per guidelines: 48px on web.
 */
export default function GooglePlayBadge({ height = 56, className = "", ariaLabel = "Get it on Google Play" }) {
  // Aspect ratio ~135:40
  const width = (height * 135) / 40;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 135 40"
      width={width}
      height={height}
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <rect width="135" height="40" rx="6.5" fill="#000" />
      <rect
        x="0.5"
        y="0.5"
        width="134"
        height="39"
        rx="6"
        fill="none"
        stroke="#A6A6A6"
        strokeWidth="0.2"
      />

      {/* Google Play triangle — official 4-color quadrant artwork */}
      <g transform="translate(9.5, 8.5)">
        <path
          d="M0.32 0.5C0.12 0.72 0 1.06 0 1.5v20c0 .44.12.78.32 1L.4 22.58 11.61 11.37v-.24L.4.42.32.5z"
          fill="url(#gpLeft)"
        />
        <path
          d="M15.35 15.11l-3.74-3.74v-.24l3.74-3.74.08.05 4.43 2.52c1.27.72 1.27 1.9 0 2.62l-4.43 2.52-.08.01z"
          fill="url(#gpTop)"
        />
        <path
          d="M15.43 15.06l-3.82-3.82L.32 22.5c.42.44 1.11.5 1.89.06l13.22-7.51"
          fill="url(#gpBottom)"
        />
        <path
          d="M15.43 7.42L2.21.14C1.43-.3.74-.24.32.2L11.61 11.24l3.82-3.82z"
          fill="url(#gpRight)"
        />
        <defs>
          <linearGradient id="gpLeft" x1="10.62" y1="1.31" x2="-4.51" y2="16.43" gradientUnits="userSpaceOnUse">
            <stop stopColor="#00A0FF" />
            <stop offset="0.007" stopColor="#00A1FF" />
            <stop offset="0.26" stopColor="#00BEFF" />
            <stop offset="0.512" stopColor="#00D2FF" />
            <stop offset="0.76" stopColor="#00DFFF" />
            <stop offset="1" stopColor="#00E3FF" />
          </linearGradient>
          <linearGradient id="gpTop" x1="20.98" y1="11.24" x2="-0.29" y2="11.24" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFE000" />
            <stop offset="0.409" stopColor="#FFBD00" />
            <stop offset="0.775" stopColor="#FFA500" />
            <stop offset="1" stopColor="#FF9C00" />
          </linearGradient>
          <linearGradient id="gpBottom" x1="13.35" y1="13.26" x2="-7.16" y2="33.77" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FF3A44" />
            <stop offset="1" stopColor="#C31162" />
          </linearGradient>
          <linearGradient id="gpRight" x1="-2.34" y1="-6.68" x2="6.83" y2="2.49" gradientUnits="userSpaceOnUse">
            <stop stopColor="#32A071" />
            <stop offset="0.069" stopColor="#2DA771" />
            <stop offset="0.476" stopColor="#15CF74" />
            <stop offset="0.801" stopColor="#06E775" />
            <stop offset="1" stopColor="#00F076" />
          </linearGradient>
        </defs>
      </g>

      {/* Text — matches Google Play badge typography */}
      <text
        x="35"
        y="15"
        fill="#fff"
        fontFamily="Roboto, -apple-system, 'Segoe UI', sans-serif"
        fontSize="6.5"
        fontWeight="400"
        letterSpacing="0.5"
      >
        GET IT ON
      </text>
      <text
        x="35"
        y="30"
        fill="#fff"
        fontFamily="Roboto, -apple-system, 'Segoe UI', sans-serif"
        fontSize="15"
        fontWeight="600"
        letterSpacing="-0.2"
      >
        Google Play
      </text>
    </svg>
  );
}
